import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ChatService } from 'src/app/chat.service';
import {  Subject } from 'rxjs';
import { debounceTime,  distinctUntilChanged } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FooterComponent implements OnInit, OnChanges {
  @Input() inputValue: string;
  @Input() numberKeypressOnly: Boolean;
  @Output() sendMsgEv = new EventEmitter();
  @Output() inputValueChange = new EventEmitter();
  @Output() fileUploadEv = new EventEmitter();

  showEmoj = true;
  questions = [
      'Hello',
      'Talk to Agent'
  ];
  uploading = false;
  displayAttachmentIcon = false;


  constructor(private _chatService: ChatService) {}

  ngOnInit() {
    this._chatService.showAttachmentIcon$.subscribe((show) => {
      this.displayAttachmentIcon = show;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.numberKeypressOnly) {
      this.numberKeypressOnly = changes.numberKeypressOnly.currentValue;
    }
  }

  change(newValue) {
    // if(this.numberKeypressOnly){
    //   this.inputValue = newValue.match(/[0-9]+/)[0];
    // } else {
    this.inputValue = newValue;
    // }
    this.inputValueChange.emit(this.inputValue);
  }

  onKey(event: any): Boolean {
    // without type info
    if (this.numberKeypressOnly && (event.keyCode < 48 || event.keyCode > 57)) {
      return false;
    } else if (
      event.keyCode !== 13
    ) {
      this._chatService.typingInProgress = true;
    } else {
      return true;
    }
  }

  sendMessage() {
    this.sendMsgEv.emit(true);
    this.inputValue = null;
  }
  importFile(files: File[]) {
      this.fileUploadEv.emit(files);

  }

  addEmoji(event) {
    if (!this.inputValue) {
      this.inputValue = '';
    }

    this.inputValue = this.inputValue + event.emoji.native;
    $('#text').val($('#text').val() + event.emoji.native);
    this.showEmoj = !this.showEmoj;

    console.log(event);
    console.log(this.inputValue);
  }

  switchEmoj() {
    this.showEmoj = !this.showEmoj;
    if (this.showEmoj == true) {
      $('.float-icon').css('z-index', '99');
    } else {
      console.log('open it ');
      $('.float-icon').css('z-index', '0');
    }
  }
}
